import React from 'react';
import Layout from '../components/layout';
import { Link } from 'gatsby';
import Slider from 'react-slick';

import display_sausage from '../img/display_sausage.jpg';
import dominick from '../img/Dominick.jpg';
import pork_king from '../img/pork_king.jpg';

function Arrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block", background: "black" }}
      onClick={onClick}
    />
  );
}

class Home extends React.Component {
	render() {
		let settings = {
			dots: false,
			arrows: true,
			lazyLoad: true,
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: true,
			speed: 1000,
			autoplaySpeed: 5000,
			cssEase: "linear",
			nextArrow: <Arrow />,
			prevArrow: <Arrow />

		};
		return(
			<Layout>
				<div className="home">
					<h3>Welcome</h3><br/>
					<p>Pork King Sausage, Inc. is a family owned and operated business located in the heart of New York City,
					we pride ourselves on staying true to our traditions and producing authentic Italian sausage with an
					uncompromised commitment to excellence.</p><br/>
					<p>Manufacturing for over 50 years, Pork King Sausage, Inc.
					is a leading producer of Italian Sausage & Pork Sausage. Under daily USDA inspection we are committed
					to rigid standards of quality. We use only the freshest ingredients and produce our products using
					old-world methods with a modern flair. Hand crafting the finest Italian Sausage <Link to="/products/" className="link">products</Link> is what we do!</p>
					<br/>
					<div className="home__slider">
						<Slider {...settings}>
							<div><img className="home__slider-img" src={display_sausage} alt="" /></div>
							<div><img className="home__slider-img" src={dominick} alt="" /></div>
							<div><img className="home__slider-img" src={pork_king} alt="" /></div>
						</Slider>
					</div>
				</div>
			</Layout>
		);
	}
}

export default Home;